/**
 * Exécute `callback` quand le DOM est prêt.
 * Si le DOM est déjà chargé au moment de l'appel, le callback est exécuté immédiatement.
 */
export function onDOMReady(callback: () => void): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    // DOM déjà prêt (interactive ou complete) → exécution synchrone
    callback();
  }
}
